import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  FiAlertCircle,
  FiAlertTriangle,
  FiCheckCircle,
  FiInfo,
  FiX,
} from "react-icons/fi";
import {
  APP_TOAST_MAX_VISIBLE,
  dismissAppToast,
  subscribeAppToasts,
} from "./showAppToast";
import "./appToast.css";

const TYPE_META = {
  success: {
    icon: FiCheckCircle,
    label: "הצלחה",
  },
  error: {
    icon: FiAlertCircle,
    label: "שגיאה",
  },
  warning: {
    icon: FiAlertTriangle,
    label: "אזהרה",
  },
  info: {
    icon: FiInfo,
    label: "מידע",
  },
};

function ToastItem({ toast, onDismiss }) {
  const timerRef = useRef(null);
  const meta = TYPE_META[toast.type] || TYPE_META.info;
  const Icon = meta.icon;

  useEffect(() => {
    if (!toast.duration || toast.duration <= 0) return undefined;
    timerRef.current = window.setTimeout(() => {
      onDismiss(toast.id, "auto_dismiss");
    }, toast.duration);
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, [toast.duration, toast.id, onDismiss]);

  return (
    <div
      className={`app-toast app-toast--${toast.type}`}
      data-toast-source={toast.source || undefined}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <span className="app-toast__icon" aria-hidden="true">
        <Icon />
      </span>
      <div className="app-toast__content">
        {toast.title ? (
          <p className="app-toast__title">{toast.title}</p>
        ) : null}
        {toast.message ? (
          <p className="app-toast__message">{toast.message}</p>
        ) : null}
      </div>
      <button
        type="button"
        className="app-toast__close"
        aria-label="סגור הודעה"
        onClick={() => onDismiss(toast.id, "manual_close")}
      >
        <FiX aria-hidden />
      </button>
    </div>
  );
}

export default function AppToastHost() {
  const [toasts, setToasts] = useState([]);

  const handleDismiss = useCallback((id, actionTaken) => {
    dismissAppToast(id, actionTaken);
  }, []);

  useEffect(() => {
    return subscribeAppToasts(({ action, payload }) => {
      if (action === "add") {
        setToasts((prev) =>
          [...prev, payload].slice(-APP_TOAST_MAX_VISIBLE)
        );
        return;
      }
      if (action === "remove") {
        setToasts((prev) => prev.filter((item) => item.id !== payload.id));
      }
    });
  }, []);

  if (!toasts.length) return null;

  return (
    <div className="app-toast-host" dir="rtl" aria-label="הודעות מערכת">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onDismiss={handleDismiss} />
      ))}
    </div>
  );
}
